import React from 'react';

const HTMLRenderer = ({ htmlContent }) => {
  // Renderizar el contenido HTML de manera segura utilizando dangerouslySetInnerHTML
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
};

export default HTMLRenderer;